import Cookies from 'js-cookie'

export const VIEWER_CART_TOKEN = '_shopify_cart'

interface CookieConfig {
  expires?: number
  path?: string
}

export const setCookie = (key: string, val: any, config?: CookieConfig) => {
  const defaults = {
    expires: 7,
    path: '/',
  }
  const settings = Object.assign(defaults, config)
  const stringified = JSON.stringify(val)
  Cookies.set(key, stringified, settings)
}

export const getCookie = (key: string) => {
  const value = Cookies.get(key)
  if (!value) return null
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

export const removeCookie = (key: string) => {
  Cookies.remove(key)
}

export const generateAnonymousUserId = () => {
  // Use crypto.getRandomValues for cryptographically secure random numbers
  const array = new Uint8Array(16)
  if (typeof window !== 'undefined' && window.crypto) {
    window.crypto.getRandomValues(array)
  } else {
    // Fallback for environments without crypto (like Node.js)
    for (let i = 0; i < 16; i++) {
      array[i] = Math.floor(Math.random() * 256)
    }
  }

  // Set version (4) and variant (8, 9, A, or B)
  array[6] = (array[6] & 0x0f) | 0x40 // Version 4
  array[8] = (array[8] & 0x3f) | 0x80 // Variant 10xx

  // Convert to hex string
  const hex = Array.from(array)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')

  // Format as UUID
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16,
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
